import * as React from 'react'
import { LandingPagesLayout } from '../../shared/components/LandingPagesLayout'
import { createSignupLink } from '../../shared/utils/SignupForm';
import { Body } from './components/Body';

export const PrivacyPolicy = () => {
  const {
    landingPageStrings,
    currentHost,
    topCities,
    privacyChoicesEnabled,
    isQuebec64FeatureEnabled,
    currentCountry,
    locale,
    deviceCategory
  } = window.gon

  return (
    <LandingPagesLayout
      signupLink={() => createSignupLink(currentHost)}
      footerContent={landingPageStrings.footer}
      currentHost={currentHost}
      currentCountry={currentCountry}
      locale={locale}
      topCities={topCities}
      privacyChoicesEnabled={privacyChoicesEnabled}
      className="px-7 xl:px-0"
    >
      <Body locale={locale} isQuebec64FeatureEnabled={isQuebec64FeatureEnabled === 'true'} />
    </LandingPagesLayout>
  )
}
